/* global React, Icon, Card, Button, Modal, AiSecHead, fmt, fmt0, PlummeI18n */
function AiiCalendarSection({ calendar, onNavigate }) {
  if (!calendar?.length) return null;
  return <section className="aii-calendar-section aii-section-frame">
    <AiSecHead icon="calendar" title={t('adv.cal.title')} sub={t('adv.cal.sub')} help={t('adv.cal.help')} />
    <div className="aii-calendar-panel">
      <div className="aii-cal">
        {calendar.map((item) => <div key={item.id} className={'aii-cal-item tone-' + item.tone}>
          <div className="aii-cal-item-top">
            <span className="aii-cal-type" data-help-title={t('adv.cal.statutory')} data-help={t('adv.help.statutoryDeadline')}>{t('adv.cal.statutory')}</span>
            <span className="aii-cal-days">{item.done
              ? t('adv.cal.done')
              : item.days == null ? '' : item.days < 0 ? t('adv.cal.overdue', { days: Math.abs(item.days) }) : t('adv.cal.daysLeft', { days: item.days })}</span>
          </div>
          <div className="aii-cal-date">{item.date}</div>
          <div className="aii-cal-label">{item.label}</div>
          {item.amount != null && item.amount > 0 && <div className="aii-cal-amount">{fmt(item.amount)}</div>}
          {item.route && <button type="button" className="aii-cal-act" onClick={() => onNavigate && onNavigate(item.route)}>
            {t('adv.cal.open')}<Icon name="chevRight" size={13} />
          </button>}
        </div>)}
      </div>
    </div>
  </section>;
}
// ============================================================
// AI Rådgiver — Oversikt: hendelsesstrøm, ansatte og analysemodal
// ============================================================
// ---------- «SuperPlumma fulgte med» ----------
// Hendelser, ikke anbefalinger: hva som faktisk har endret seg i regnskapet. Rødt
// haster, gult bør følges opp, grønt er bare til info. Teksten oversettes her — modellen
// leverer { key, vars }, aldri ferdig tekst.
const aiiFeedVars = (vars) => {
  const out = {};
  Object.entries(vars || {}).forEach(([key, value]) => {
    out[key] = key === 'amount' && Number.isFinite(Number(value)) ? fmt(Number(value)) : value;
  });
  return out;
};
function AiiFeedSection({ feed, onAct }) {
  const [open, setOpen] = React.useState(false);
  if (!feed?.length) return null;
  return <Card className={'aii-feed-card' + (open ? ' is-open' : '')}>
    <AiSecHead icon="bell" title={t('adv.feed.title')} sub={t('adv.feed.sub')} help={t('adv.feed.help')}
      right={<button type="button" className="aii-feed-toggle" onClick={() => setOpen((value) => !value)}
        aria-expanded={open} aria-controls="aii-feed-details">
        <span>{t(open ? 'adv.basis.collapse' : 'adv.basis.expand')}</span>
        <Icon name={open ? 'chevUp' : 'chevDown'} size={16} />
      </button>} />
    {open && <div id="aii-feed-details" className="aii-feed" style={{ marginTop: 8 }}>
      {feed.map((item, i) => <div key={i} className={'aii-feed-item tone-' + (item.tone || 'amber')}>
        <span className="aii-feed-ico"><Icon name={item.icon || 'sparkle'} size={17} /></span>
        <div className="aii-feed-main">
          <div className="aii-feed-title">{t('adv.feed.' + item.key + '.title', aiiFeedVars(item.vars))}</div>
          <div className="aii-feed-body">{t('adv.feed.' + item.key + '.body', aiiFeedVars(item.vars))}</div>
        </div>
        {(item.tab || item.route) && <button type="button" className="aii-feed-act"
          onClick={() => onAct && onAct({ tab: item.tab, route: item.route })}>
          {t('adv.feed.seeDetails')}<Icon name="arrowRight" size={14} />
        </button>}
      </div>)}
    </div>}
  </Card>;
}

// ---------- Betinget modul: Ansatte & lønn ----------
// Vises bare når bedriften faktisk har ansatte eller lønnskjøringer. Uten lønnsdata er
// modulen ikke tom — den er ikke relevant.
function AiiEmployeesModule({ employees, onNav }) {
  if (!employees) return null;
  const figures = [
    { key: 'count', value: String(employees.employeeCount) },
    employees.payrollShare != null ? { key: 'share', value: `${PlummeI18n.number(employees.payrollShare, { maximumFractionDigits: 1 })} %` } : null,
    employees.payrollCost > 0 ? { key: 'cost', value: fmt(employees.payrollCost) } : null,
    employees.runsThisYear > 0 ? { key: 'runs', value: String(employees.runsThisYear) } : null,
  ].filter(Boolean);
  return <div className="aii-cond-grid">
    <div className="aii-cond-mod" data-help-title={t('adv.employees.title')} data-help={t('adv.employees.help')}>
      <div className="aii-cond-head">
        <span className="aii-cond-ico"><Icon name="users" size={17} /></span>
        <span className="aii-cond-title">{t('adv.employees.title')}</span>
      </div>
      <div className="aii-cond-figs">
        {figures.map((figure) => <div key={figure.key}>
          <span className="lbl">{t('adv.employees.' + figure.key)}</span><b>{figure.value}</b>
        </div>)}
      </div>
      <p className="t-xs muted">{t('adv.employees.note')}</p>
      <button type="button" className="aii-move-btn" onClick={() => onNav && onNav('lonn')}>{t('adv.employees.go')}</button>
    </div>
  </div>;
}

// ---------- Analysemodal — den genererte AI-analysen ----------
// Analysen ligger bak «Se analyse» i heroen i stedet for som et eget kort på siden:
// den er utdypning, ikke det første du skal lese.
function AiiAnalysisModal({ open, onClose, panel }) {
  if (!open) return null;
  return <Modal open portal center onClose={onClose} className="aii-work-modal" title={t('adv.analysis.title')}>
    <div className="aii-analysis-modal">
      {panel || <p className="t-sm muted">{t('adv.analysis.empty')}</p>}
    </div>
  </Modal>;
}

Object.assign(window, { AiiCalendarSection, AiiFeedSection, AiiEmployeesModule, AiiAnalysisModal, aiiFeedVars });
